import { render, staticRenderFns } from "./index.vue?vue&type=template&id=39b3b189&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "../college/logo-layout.css?vue&type=style&index=0&id=39b3b189&prod&scoped=true&lang=css&external"
import style1 from "./index.vue?vue&type=style&index=1&id=39b3b189&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b3b189",
  null
  
)

export default component.exports